import { suggestedPrompts } from '../../data/oracleResponses.js';

/**
 * SuggestedPrompts — empty-state grid of conversation starters.
 *
 * Renders only when the user hasn't sent a message yet. Tapping a chip
 * submits the prompt immediately (skipping the input field) — matching the
 * pattern users see in mainstream LLM apps.
 */
export default function SuggestedPrompts({ onPromptSelected }) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-2 py-6 text-center animate-fade-in">
      <div className="relative mb-6">
        <div className="absolute inset-0 rounded-full bg-f1-red/30 blur-2xl" />
        <div className="relative flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-f1-red to-f1-redDeep shadow-glow-red animate-pulse-red">
          <span className="text-2xl font-bold text-white">F1</span>
        </div>
      </div>

      <h2 className="text-xl font-bold text-ink-primary">Ask the Oracle</h2>
      <p className="mt-2 max-w-xs text-sm leading-relaxed text-ink-secondary">
        Live telemetry analysis, historical trivia, regulation explainers, race strategy — all in
        one place.
      </p>

      <div className="mt-7 grid w-full grid-cols-2 gap-2">
        {suggestedPrompts.map((prompt) => (
          <button
            key={prompt.id}
            onClick={() => onPromptSelected(prompt.label)}
            className="pressable group flex items-start gap-2 rounded-2xl bg-bg-card p-3 text-left ring-1 ring-stroke transition-all hover:bg-bg-card2 hover:ring-f1-red/40"
          >
            <span className="text-lg" aria-hidden="true">
              {prompt.icon}
            </span>
            <span className="text-2xs font-semibold leading-snug text-ink-secondary group-hover:text-ink-primary">
              {prompt.label}
            </span>
          </button>
        ))}
      </div>

      <p className="mt-6 text-[10px] uppercase tracking-widest-plus text-ink-muted">
        Responses are AI-generated · Beta release
      </p>
    </div>
  );
}
